import React, { useCallback, useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import {
  popupStore,
  applicationStore,
  userSettingsStore,
  GameLaunchManager,
  PlatformMessagesWrapper,
  PostMessageListenerMessages,
  LoadingContainer,
  betStore,
} from '@pascal/pascal-core';

import { gameConfigStore, roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { AppDefaultValuesEnum, RoutePaths } from './enums';
import { FactoryRouter, SocketConnection } from './core';
import { gameLiveConnection } from './services';
import GameWebMobileContainer from './containers/gameWebMobileContainer';
import { socketEventsHandlerDelays } from './enums/replaySocetEventsDelays';
import { betTypesStore } from './store/betTypesStore';

let timeoutId;

const App = () => {
  const components = useMemo(
    () => [
      {
        path: RoutePaths.game,
        element: <GameWebMobileContainer />,
        defaultRedirectComponent: true,
      },
      {
        path: RoutePaths.replay,
        element: <GameWebMobileContainer />,
      },
    ],
    []
  );

  const lostInternetConnection = useCallback(() => {
    popupStore.toggleReconnect(true);
    timeoutId = setTimeout(() => {
      popupStore.toggleReconnect(false);
      popupStore.onConnectionError(true);
      gameLiveConnection.stop();
    }, 5000);
  }, []);

  const reconnectInternet = useCallback(() => {
    if (!popupStore.connectionError) {
      clearTimeout(timeoutId);
      popupStore.toggleReconnect(false);
    }
  }, [popupStore.connectionError]);

  useEffect(() => {
    userSettingsStore.isDarkModeOn
      ? document.documentElement.classList.add('dark')
      : document.documentElement.classList.remove('dark');
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  useEffect(() => {
    applicationStore.setIsBogLine(true);
    const intervalId = setInterval(() => {
      return window.location.pathname === RoutePaths.game && gameLiveConnection.sendPing();
    }, 3000);

    return () => {
      intervalId && clearInterval(intervalId);
    };
  }, []);
  const repliedCallback = () => {
    const { repliedBetData } = betStore;
    roundInfoStore.setDuration(6);
    gameConfigStore.setLimits(repliedBetData?.replayData.limits);
    betTypesStore.setBetTypes(repliedBetData?.replayData.gameConfiguration.markets);
    const selectedBetColor = repliedBetData?.replayData?.markets?.find(
      (item) => item.odd === repliedBetData.odd
    ).color;
    betTypesStore.setSelectedType({ odd: repliedBetData.odd, color: selectedBetColor });
  };
  return (
    <BrowserRouter>
      <LoadingContainer
        appDefaultValuesEnum={AppDefaultValuesEnum}
        gameSpecificRepliedCallback={repliedCallback}
      >
        <PlatformMessagesWrapper
          additionalMessagesParams={[
            {
              name: PostMessageListenerMessages.UpdateBalance,
              callback: () => {
                gameLiveConnection.getBalance();
              },
            },
          ]}
        >
          <GameLaunchManager
            socketEventsHandlerDelays={socketEventsHandlerDelays}
            GameContainer={<FactoryRouter components={components} />}
            SocketConnectionWr={
              <SocketConnection>
                <FactoryRouter components={components} />
              </SocketConnection>
            }
          />
        </PlatformMessagesWrapper>
      </LoadingContainer>
    </BrowserRouter>
  );
};

export default App;
